import { FlipperKey } from '~/store/flippers/types'
import { StateFlippers } from './reducer'

export type StateFlipperKey = keyof StateFlippers

export type FlipperResponseMap = Record<FlipperKey, StateFlipperKey>

export enum EARN_ACTIONS {
  SET_FLIPPERS = 'EARN_ACTIONS.SET_FLIPPERS',
}

type SetFlippers = {
  type: typeof EARN_ACTIONS.SET_FLIPPERS
  flippers: Map<StateFlipperKey, boolean>
}

export type ActionTypes = SetFlippers
